import { useContext, useState } from 'react'
import {
    StyleButtonWrapper,
    StyledActionGroup,
    StyledDeleteAccount,
} from './DeleteAccount.styled'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import React from 'react'
import { UserSettingsLink } from '../components/UserSettingsLink'
import { UserSettingsButton } from '../components/UserSettingsButton'
import { tokens } from '@news-mono/design-tokens'
import { AppState, ConfigurationContext, Product } from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { useForgotPassword } from '../hooks/useChangePassword'
import { useDeleteAccount } from '../hooks/useDeleteAccount'
import { isEmpty } from 'lodash'
import { UserSettingsInput } from '../components/UserSettingsInput'
import {
    DeleteAccountClickProps,
    onDeleteAccountClick,
    onForgotPasswordClick,
} from './helpers/delete-account-click-helper'
import { useProduct } from '../../__product'

const { utility } = tokens.thenightly.colors.palette
const { pinkThulite } = tokens.perthnow.colors.palette

export const DeleteAccountPassword = () => {
    const [password, setPassword] = useState<string>()
    const [submitting, setSubmitting] = useState<boolean>(false)

    const config = useContext(ConfigurationContext)
    const myAccountContext = useContext(MyAccountContext)

    const product = useProduct()
    const isPn = product === Product.PerthNow

    const { setScreen, setScreenSelected } = myAccountContext

    const { userEmail, wanUserId, auth0UserId } = useSelector(
        (state: AppState) => state.authentication,
    )

    const { mutateAsync: sendForgotPasswordEmail } = useForgotPassword({
        email: userEmail!,
    })
    const { mutateAsync: deleteAccount } = useDeleteAccount({
        userId: auth0UserId || wanUserId,
        currentPassword: password!,
        email: userEmail!,
        passEncryptionKey: config.auth0!.passEncryptionKey!,
    })

    const deleteAccountProps: DeleteAccountClickProps = {
        myAccountContext,
        configContext: config,
        mutateProps: {
            onDeleteAccount: deleteAccount,
            sendForgotPasswordEmail,
        },
        passwordState: {
            passwordText: password,
        },
    }

    return (
        <StyledDeleteAccount>
            <UserSettingsInput
                id="current-password"
                label={isPn ? 'Password*' : 'Enter Password'}
                type="password"
                onChange={(value) => setPassword(value)}
            />
            <UserSettingsLink
                onClick={async () => {
                    setSubmitting(true)
                    await onForgotPasswordClick(deleteAccountProps)
                    setSubmitting(false)
                }}
                color={''}
                textTransform="none"
            >
                Forgot your password?
            </UserSettingsLink>
            <StyledActionGroup>
                <UserSettingsLink
                    color={isPn ? pinkThulite : utility.error.default}
                    onClick={async () => {
                        setSubmitting(true)
                        await onDeleteAccountClick(deleteAccountProps)
                        setSubmitting(false)
                    }}
                    disabled={isEmpty(password) || submitting}
                    fontWeight={600}
                    underline={false}
                >
                    Delete my account
                </UserSettingsLink>
                <StyleButtonWrapper>
                    <UserSettingsButton
                        onClick={() => {
                            setScreen('manage-account')
                            setScreenSelected(true)
                        }}
                        btnType="primary"
                        disabled={submitting}
                    >
                        Cancel
                    </UserSettingsButton>
                </StyleButtonWrapper>
            </StyledActionGroup>
        </StyledDeleteAccount>
    )
}
